// extracted by mini-css-extract-plugin
module.exports = {"Container":"GoogleButton_Container__5LQ2a","Icon":"GoogleButton_Icon__jYXWU","Text":"GoogleButton_Text__3You2"};